<template>
  <div>
    <div id="print">
      <vuetable
        ref="vuetable"
        :fields="tablefields"
        :api-mode="false"
        :data="tabledata"
        no-data-template
      >
        <span slot="sq" slot-scope="props">{{props.rowIndex+1}}</span>

        <span slot="number" slot-scope="props">
          <span v-if="submitted">{{props.rowData[changer]}}</span>
          <el-input-number
            v-else
            v-model="props.rowData[changer]"
            @change="setvalue(qtychange,props.rowIndex,changer,$event)"
            :min="0"
            :step="0.5"
            :max="clctto==='_out'?props.rowData[changee]:10000000"
          ></el-input-number>
        </span>
        <!-- <span slot="caculator" slot-scope="props">{{props.rowData.number*props.rowData.length}}</span> -->
        <span slot="remark" slot-scope="props">
          <span v-if="submitted">{{props.rowData.remark}}</span>
          <!-- <el-input
            v-else
            type="text"
            placeholder="备注"
            v-model="props.rowData.remark"
            @change="setvalue(qtychange,props.rowIndex,'remark',$event)"
            maxlength="40"
            show-word-limit
          ></el-input>-->
          <input
            v-else
            type="text"
            placeholder="备注"
            maxlength="50"
            class="form-control"
            v-model="props.rowData.remark"
            @input="setvalue(qtychange,props.rowIndex,'remark',$event.target.value)"
          />
        </span>
        <span slot="remove" slot-scope="props">
          <el-button type="warning" @click="removeitem(props.rowIndex)">X</el-button>
        </span>
      </vuetable>
      <el-button
        v-loading="$store.state.loading"
        type="primary"
        style="width:100%"
        v-if="!submitted && tabledata.length!=0"
        @click="tabledone"
      >完成</el-button>

      <el-drawer direction="ttb" size="100%" center v-loading="$store.state.loading" :visible.sync="showdialog" >
        <img alt="logo" style="height:2em" class="logo" src="static/warehouse.png" />
        <div style="margin-top:2rem">
        <p  v-show="selected.length<3">{{"请选择第"+(selected.length+1)+"审批人"}}</p>
        <p v-show="selected.length===3">已选择，现在可以提交表单了</p>
        </div>
        <el-button-group>
          <el-button
            v-show="(selected.length<2?(x.weight===selected.length+1):(x.roles?x.weight>3:false))||selected.includes(x.name)"
            v-for="x in approvers"
            :key="x.name"
            @click="selectedfn(x)"
            v-bind:style="{'color':selected.includes(x.name)?'red':'black'}"
          >{{x.name}}</el-button>
        </el-button-group>
        <!-- <span slot="footer" class="dialog-footer"> -->
          <div style="margin-top:3rem">
          <el-button @click="showdialog = false">取消</el-button>
          <el-button v-show="selected.length===3" type="primary" @click="submit">提交</el-button>
          </div>
        <!-- </span> -->
      </el-drawer>

      <div style="margin-top:100px" v-if="tabledata.length===0">
        <p style="font-size:2em;font-weight:bold">你还未进行选择，请转至首页数据库进行搜索查询</p>
        <el-button type="primary" @click="$router.push('/')">跳转至查询页</el-button>
      </div>

      <div v-if="submitted" style="color:red">
        <el-button v-if="!downloaded" @click="downloadpdf()">下载PDF download</el-button>
        <p>
          <span>已提交成功</span>
          <span v-if="downloaded">,请查看下载文件</span>
        </p>
      </div>

      <!-- <div v-if="submitted" style="margin-top:5em">
        <el-row>
          <el-col :span="8" v-for="x in selected" :key="x">
            {{x}}
            <br>签字
          </el-col>
        </el-row>
      </div>-->
    </div>
    <!-- <el-button type="primary" v-if="submitted" v-print="'#print'">打印</el-button> -->
  </div>
</template>

<script>
import Vuetable from "vuetable-2";
//import tabletopdf from "./tabletopdf"
// import { fields } from "../presentation/vuetablefields.js";
// import {formatter} from "../presentation/utility/formatter"
import { fieldsprocess } from "zxg-table-fieldsprocess";
// import { downloadpdf } from "@/components/utility/downloadpdf";
import moment from "moment";
export default {
  components: {
    Vuetable
  },
  props: ["qtychange", "clctto","changer","changee"],
  data() {
    return {
      showdialog: false,
      approvers: [],
      selected: [],
      tablefields: fieldsprocess(this.$store.state.currentheader, "qtychange",this.$store),
      submitted: false,
      downloaded: false
      // submitteditems:[],
      //fields:
    };
  },
  //mounted(){console.log(this.tablefields)},
  computed: {
    tabledata() {
      //console.log(this.$store.state[this.qtychange])
      return this.$store.state[this.qtychange];
    }
  },

  destroyed() {
    if (this.submitted) {
      this.$store.commit("resetitems", this.qtychange);
    }
  },
  methods: {
    setvalue(target, index, key, value) {
      let obj = { target: target, index: index, key: key, value: value };
      this.$store.commit("setvalue", obj);
    },
    selectedfn(x) {
      // //检查是否选中
      let index = this.selected.findIndex(val => {
        return val === x.name;
      });
      //如未选中
      if (index < 0) {
        if (this.selected.length === 3) {
          //如长度为3，那么移除最后一个选项
          this.selected.splice(-1, 1);
        }
        this.selected.push(x.name); //插入新选项
      } else {
        this.selected.splice(index);
      }
    },

    tabledone() {
      //tabletopdf(this.tablefields,this.tabledata)
      this.$axios.get(url + "approvers").then(res => {
        this.approvers = res.data;

        this.showdialog = true&&!this.submitted;//避免submitted以后再次提交
      });
    },
    submit() {
      if (this.selected.length < 3) {
        this.$message("需选择3人审批");
        return false;
      }
      // let items = this.tabledata;
      //let receivers=this.selected

      let newitems = [];
      this.tabledata.forEach(obj => {
       
        let newobj = {
          _id: obj._id,
          // number: obj.number,
          remark: obj.remark || "无",
          receivers: this.selected
        };
        newobj[this.changer]=obj[this.changer]
        //在前端生成完整信息，该语句用于有计算的情况
        Object.assign(obj, newobj);
        //以下两语句用于删除obj中含inlineform及theform信息的情况
        delete obj.inlineform
        delete obj.theform
        newitems.push(obj);

        //newitems.push(newobj);
      });



      let clct = this.$store.state.collection.value;
      //console.log(clct)

      this.$axios
        .post(
          url + "qtychange",
          { items: newitems, clctfrom: clct, clctto: this.clctto }
          // { responseType: "blob" }
        )
        .then(res => {
          this.showdialog = false;
          this.submitted = true;
          this.tablefields.forEach((obj, index) => {
            if (obj.name === "remove") {
              obj.visible = false;
              this.$set(this.tablefields, index, obj);
            }
          });
          // //console.log(res.data);
          // let url = URL.createObjectURL(res.data);
          // let link = document.createElement("a");
          // link.download = moment().format("YYYYMMDDHHmmss") + ".pdf";
          // link.href = url;
          // link.click();
        });
    },

    downloadpdf(){
      let objreceivers={}
        this.selected.forEach(val => {
        objreceivers[val] = "未确认";
      });
      this.tabledata.forEach(obj=>{
        obj.receivers=objreceivers
      })
      this.$axios.downloadpdf(this.$store.state.user,this.$store.state.clct + this.clctto,this.tabledata)
      .then(this.downloaded=true)
    },

    // downloadpdf_discard(printintheclct,printitems,signature) {
    //   let receivers =printitems.receivers
    //   if(!receivers){
    //     receivers={}
    //     signature.forEach(val=>{
    //       receivers[val]="未确认"
    //     })
    //   //   printitems.forEach(val => {
    //   //   printitems.receivers[val] = "未确认";
    //   // });
    //   }


    //   printitems.forEach(obj => {
    //     // obj.id = obj._id;
    //     obj.receivers = receivers;
    //     obj.remark = obj.remark || "无";
    //     // delete obj._id;
    //   });
    //   // this.submitteditems=items//this is for pdfdownload

    //   let data = {};
    //   // data.collection = this.$store.state.clct + this.clctto;
    //   data.collection=printintheclct
    //   data.items = printitems;
    //   data.items[0].name = this.$store.state.user;
    //   this.$axios
    //     .post(url + "downloadpdf", data, { responseType: "blob" })
    //     .then(res => {
    //       let url = URL.createObjectURL(res.data);
    //       let link = document.createElement("a");
    //       link.download = moment().format("YYYYMMDDHHmmss") + ".pdf";
    //       link.href = url;
    //       link.click();
    //       this.downloaded = true;
    //     });
    // },
    removeitem(data) {
      this.$store.commit("removeitem", {
        where: this.qtychange,
        itemindex: data
      });
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/qtychange/qtychange.vue